import { createSectionName } from 'components/Dashboard/helpers/controlActiveFilters';
import { changeTypeOfResource } from 'components/Dashboard/helpers/createTypeOfResource';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import useNumberOfUnseenItems from 'components/Dashboard/hooks/useNumberOfUnseenItems';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { useContext, useEffect, useRef } from 'react';
import { store } from 'components/Store';

const DEFAULT_INTERVAL_MS = 30000;

const useIntervalCreateResults = (props) => {
  const {
    callCondition,
    currentlyProcessing,
    contentFilters,
    noIntervalCall = false,
    setFreshItemsCount,
    refreshTrigger,
    isLoading,
  } = props ?? {};

  const globalState = useContext(store);
  const { state } = globalState;
  const { keywordsLists } = state;
  const sectionName = createSectionName();
  const { inboxSection } = useMainSectionParameter();
  const { callUnseenItemsList } = useNumberOfUnseenItems();

  const topicParam = getUrlParam('topic-id');
  const searchParam = getUrlParam('search') ?? getUrlParam('or');

  const intervalCallInProgressRef = useRef(false);

  const isParliamentLive = sectionName === 'ParliamentLive';
  const shouldRunInterval =
    inboxSection && !isParliamentLive && callCondition && currentlyProcessing?.state === true && !noIntervalCall;

  const intervalCallRef = useRef(null);
  intervalCallRef.current = async () => {
    if (intervalCallInProgressRef.current) {
      return;
    }
    intervalCallInProgressRef.current = true;
    try {
      const list = keywordsLists?.find((item) =>
        topicParam === 'all' ? item?.id === null : item?.id === parseInt(topicParam)
      );
      if (topicParam !== 'all' && !list) {
        return;
      }
      const totalNumbers = await callUnseenItemsList({ listId: list?.id ?? null });
      if (setFreshItemsCount && totalNumbers) {
        const count = totalNumbers[changeTypeOfResource(sectionName)] ?? 0;
        setFreshItemsCount(count);
      }
    } catch (error) {
    } finally {
      intervalCallInProgressRef.current = false;
    }
  };

  useEffect(() => {
    if (!shouldRunInterval) return;

    if (setFreshItemsCount) {
      setFreshItemsCount(0);
    }
    const id = setInterval(() => intervalCallRef.current(), DEFAULT_INTERVAL_MS);
    return () => {
      clearInterval(id);
      intervalCallInProgressRef.current = false;
    };
  }, [
    sectionName,
    topicParam,
    searchParam,
    contentFilters,
    currentlyProcessing?.state,
    callCondition,
    noIntervalCall,
    shouldRunInterval,
    inboxSection,
    refreshTrigger,
  ]);
};

export default useIntervalCreateResults;
